<template>

  <v-app>

    <v-main>

      <!-- ===================== -->
      <!-- Datenschutzerklärung -->
      <!-- ===================== -->

      <div class="datenschutz-page">

        <div class="datenschutz-container">

          <!-- ==================== DATENSCHUTZ ==================== -->

          <section class="text-left">

            <h1 class="text-h4 mb-8 text-center text-decoration-underline">
              Datenschutz
            </h1>


            <h2 class="text-h6 mb-3">
              1. Datenschutz auf einen Blick
            </h2>

            <p>
              Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen.
              Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
              den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>

            <p>
              Wenn Sie diese Website nutzen, werden verschiedene personenbezogene Daten erhoben.
              Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              2. Verantwortlicher
            </h2>

            <p>
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist die
              im Impressum dieser Website genannte natürliche oder juristische Person.
            </p>

            <p>
              Die Kontaktdaten des Verantwortlichen finden Sie im Impressum dieser Website.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              3. Hosting
            </h2>

            <p>
              Diese Website wird bei der ALL-INKL.COM – Neue Medien Münnich,
              Hauptstraße 68, 02742 Friedersdorf, Deutschland gehostet.
            </p>

            <p>
              Beim Aufruf der Website werden automatisch Informationen durch den Webserver
              erfasst und in sogenannten Server-Logfiles gespeichert. Hierzu gehören insbesondere:
            </p>

            <ul class="ml-6">
              <li>IP-Adresse (ggf. anonymisiert)</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>aufgerufene Seiten</li>
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer-URL</li>
              <li>Hostname des zugreifenden Rechners</li>
            </ul>

            <p>
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
              Unser berechtigtes Interesse besteht in der technisch fehlerfreien
              Bereitstellung und Sicherheit der Website.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              4. Kontaktaufnahme per E-Mail
            </h2>

            <p>
              Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen übermittelten
              personenbezogenen Daten (z. B. Name, E-Mail-Adresse und Inhalt Ihrer Nachricht)
              ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet.
            </p>

            <p>
              Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
              der Durchführung vorvertraglicher Maßnahmen oder eines Vertrages dient.
              In allen übrigen Fällen erfolgt die Verarbeitung auf Grundlage unseres
              berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO an der Bearbeitung
              Ihrer Anfrage.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              5. Cookies
            </h2>

            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies,
              soweit dies für den Betrieb der Website erforderlich ist.
            </p>

            <p>
              Es werden keine Cookies zu Analyse-, Marketing- oder Werbezwecken eingesetzt.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              6. SSL- bzw. TLS-Verschlüsselung
            </h2>

            <p>
              Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
              vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
              Verbindung erkennen Sie daran, dass die Adresszeile Ihres Browsers mit
              „https://“ beginnt und ein Schloss-Symbol angezeigt wird.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              7. Speicherdauer
            </h2>

            <p>
              Personenbezogene Daten werden nur so lange gespeichert, wie dies zur
              Erfüllung des jeweiligen Zwecks erforderlich ist oder gesetzliche
              Aufbewahrungsfristen bestehen.
            </p>

            <p>
              Nach Wegfall des jeweiligen Zwecks bzw. Ablauf der gesetzlichen Fristen
              werden die Daten entsprechend den gesetzlichen Vorschriften gelöscht.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              8. Ihre Rechte
            </h2>

            <p>
              Sie haben jederzeit das Recht auf:
            </p>

            <ul class="ml-6">
              <li>Auskunft gemäß Art. 15 DSGVO</li>
              <li>Berichtigung gemäß Art. 16 DSGVO</li>
              <li>Löschung gemäß Art. 17 DSGVO</li>
              <li>Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
              <li>Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
              <li>Widerspruch gegen die Verarbeitung gemäß Art. 21 DSGVO</li>
            </ul>

            <p>
              Sofern Sie eine Einwilligung zur Verarbeitung Ihrer Daten erteilt haben,
              können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              9. Beschwerderecht
            </h2>

            <p>
              Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die
              Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              10. Pflicht zur Bereitstellung personenbezogener Daten
            </h2>

            <p>
              Eine gesetzliche oder vertragliche Verpflichtung zur Bereitstellung
              personenbezogener Daten besteht grundsätzlich nicht. Ohne die Bereitstellung
              bestimmter Daten kann jedoch eine Bearbeitung Ihrer Anfrage per E-Mail
              gegebenenfalls nicht erfolgen.
            </p>


            <h2 class="text-h6 mt-8 mb-3">
              11. Änderungen dieser Datenschutzerklärung
            </h2>

            <p>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
              stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen
              unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die
              jeweils aktuelle Datenschutzerklärung.
            </p>

          </section>

        </div>

      </div>

    </v-main>

  </v-app>

</template>


<style scoped>

.datenschutz-page {
  width: 100%;
  min-height: 100vh;

  background: #ffffff;

  padding: 60px 20px 80px;
}


/* ============================================================
   ZENTRALER INHALTSBEREICH
============================================================ */

.datenschutz-container {
  width: 100%;
  max-width: 1000px;

  margin: 0 auto;

  color: #111111;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  font-size: 15px;
  line-height: 1.8;
}


/* ============================================================
   ÜBERSCHRIFTEN
============================================================ */

.datenschutz-container h1 {
  color: #111111;

  font-weight: 700;

  margin-bottom: 50px;
}


.datenschutz-container h2 {
  color: #111111;

  font-weight: 700;

  margin-top: 35px;
}


/* ============================================================
   ABSÄTZE
============================================================ */

.datenschutz-container p {
  margin-top: 0;
  margin-bottom: 18px;

  color: #222222;

  line-height: 1.8;
}


/* ============================================================
   LISTEN
============================================================ */

.datenschutz-container ul {
  margin-top: 10px;
  margin-bottom: 20px;

  padding-left: 25px;
}


.datenschutz-container li {
  margin-bottom: 5px;
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  .datenschutz-page {
    padding: 40px 20px 60px;
  }

  .datenschutz-container {
    width: 100%;

    font-size: 14px;

    line-height: 1.7;
  }

  .datenschutz-container h1 {
    font-size: 28px !important;

    margin-bottom: 40px;
  }

  .datenschutz-container h2 {
    font-size: 18px !important;

    margin-top: 30px;
  }

  .datenschutz-container p {
    line-height: 1.7;
  }

}


/* ============================================================
   SEHR KLEINE GERÄTE
============================================================ */

@media (max-width: 450px) {

  .datenschutz-page {
    padding: 30px 15px 50px;
  }

  .datenschutz-container {
    font-size: 13px;
  }

  .datenschutz-container h1 {
    font-size: 25px !important;
  }

  .datenschutz-container h2 {
    font-size: 17px !important;
  }

}

</style>